import React, { useEffect, useState } from "react";
import bulmaCalendar from "bulma-calendar";
import './style.scss';


const DatePicker = ({ id, label, name, value, onChange }) => {
    const options = {
        startDate: new Date()
    };

    const [calendar, setCalendar] = useState();

    const handleChange = (v) => {
        let date = null;
        if (v) { date = new Date(v); }

        if (onChange) {
            onChange({ target: { name, value: date } });
        }
    }

    useEffect(() => {
        const init = () => {

            if (value) {
                options.startDate = new Date(value);
            }

            const c = bulmaCalendar.attach(`#${id}`, options)[0];
            c.on('select', (date) => {
                handleChange(date.data.value());
            });

            setCalendar(c);
        }

        if (!calendar) {
            init();
        }
    });

    return (
        <div className="field">
            <label className="label">{label}</label>
            <div className="control">
                <input id={id} name={name} type="date" readOnly></input>
            </div>
        </div>
    );
};

export { DatePicker };
